import React from "react";
import { useNavigate } from "react-router-dom";
import { Stack } from "../../components"
import { useRequest } from "../../http"
import { IDoctorWithRoom } from "../../models";
import { DoctorItem } from "./doctorItem";

export const DoctorsList = () => {

  const { data, loading, error, execute } = useRequest<Array<IDoctorWithRoom>>('DoctorsWithRooms');
  const inactiveTimeoutSeconds = 15;
  const timerRef = React.useRef<any>();
  const navigate = useNavigate();
  const [sortedDoctors, setSortedDoctors] = React.useState<Array<IDoctorWithRoom>>();

  const startBackTimeout = React.useCallback(() => {
    const timer = () => setTimeout(() => {
      navigate("/");
    }, inactiveTimeoutSeconds * 1000);

    timerRef.current = timer();
  }, [navigate]); // This is stupid but the linter is boss.
  // The early return in the useEffect below fixes it (so that loading and startTimeout is not ran multiple times)
  // If navigate is removed from the useCallback dependency array, 
  // or startBackTimeout is removed from the useEffect dependency array, 
  // it works without the first if in the useEffect. Pls refactor me :(

  React.useEffect(() => {
    if (timerRef.current) {
      // Already loading the stuff or navigating away - do not start new shit now pls
      return;
    }

    const run = async () => {
      await execute();
      // Only start the back-timeout after the request is completed
      startBackTimeout();
    }

    run();

    return () => {
      if (timerRef.current) {
        clearTimeout(timerRef.current);
      }
    };
  }, [execute, startBackTimeout]);

  React.useEffect(() => {
    if (!data) {
      return;
    }

    const sorted = [...data].sort((a, b) => a.doctor.name.localeCompare(b.doctor.name));
    console.log({ sorted });
    setSortedDoctors(sorted);
  }, [data]);

  if (loading) {
    return (
      <Stack horizontal horizontalAlign="center">
        <div>Laster...</div>
      </Stack>
    )
  }

  if (error) {
    return (
      <Stack horizontal horizontalAlign="center">
        <div>Kunne ikke laste leger...</div>
      </Stack>
    )
  }

  return (
    <Stack>
      <Stack horizontal horizontalAlign="center" $wrap={true} gap={100} >
        {sortedDoctors?.map(item => <DoctorItem doctor={item.doctor} key={item.doctor.id.value} room={item.room} />)}
      </Stack>
    </Stack>
  )
}